<template>
  <div>
    <div class="footer2 row">
      <div class="left col-contato">
        <div class="contato">
          <p>
            <span class="icone-whatsapp"
              ><i class="icofont-brand-whatsapp"></i
            ></span>
            (83) 98134-7977
          </p>
          <p v-if="$store.state.orcamento.empresa === 'esusfeedback'">
            contato@esusfeedback.com.br
          </p>
          <p v-else>contato@biatic.com.br</p>
          <div class="redes-sociais">
            <span v-if="$store.state.orcamento.empresa === 'esusfeedback'"
              ><span class="icone-instagram"
                ><i class="icofont-instagram"></i></span
              >esusfeedback</span
            >
            <span v-else
              ><span class="icone-instagram"
                ><i class="icofont-instagram"></i></span
              >biatic</span
            >
            <span
              ><span class="icone-youtube"
                ><i class="icofont-youtube-play"></i></span
              >/esusfeedback</span
            >
          </div>
        </div>
      </div>
      <div class="right col-endereco">
        <div
          v-if="$store.state.orcamento.empresa === 'esusfeedback'"
          class="endereco"
        >
          <p>CNPJ: 45.180.436/0001-48</p>
          <p>Rua Antônio Ferreira Ramalho, nº 43, Sala 101</p>
          <p>CEP: 58980-000, Ibiarinha, Ibiara-PB.</p>
        </div>
        <div v-else class="endereco">
          <p>CNPJ: 27.197.452/0001-61</p>
          <p>Rua Antônio Ferreira Ramalho, nº 43, Sala 102</p>
          <p>CEP: 58980-000, Ibiarinha, Ibiara-PB.</p>
        </div>
      </div>
    </div>
    <div id="proposta">
      <!-- init new page -->
      <div class="new-page">
        <div class="row flex-column">
          <b-button
            class="imprimir"
            type="button"
            variant="primary"
            @click="imprimir()"
            >Imprimir ou PDF</b-button
          >
          <img
            v-if="$store.state.orcamento.empresa === 'biatic'"
            src="@/assets/images/proposta/biatic.png"
            class="logo"
            alt="biatic"
          />
          <img
            v-else
            src="@/assets/images/proposta/esusfeedback.png"
            class="logo"
            alt="esusfeedback"
          />
        </div>

        <p
          v-if="$store.state.orcamento.empresa === 'biatic'"
          class="titulo-principal"
        >
          A Biatic executa prestação de serviço especializado em análise de
          dados em saúde e Monitoramento e Avaliação na Atenção Primária à Saúde
          (APS). Ações que contribuem para acompanhar a qualidade da assistência
          a população municipal e consequentemente atender aos requisitos do
          Cofinanciamento federal 2024 e a maximização de recursos federais para
          a APS.
        </p>
        <p v-else class="titulo-principal">
          A eSUS Feedback presta serviço especializado em Busca Ativa,
          Monitoramento e Avaliação (M & A) na Atenção Primária à Saúde (APS).
          As ações de M & A na APS contribuem diretamente para acompanhar a
          qualidade da assistência à população municipal, atender aos requisitos
          do Cofinanciamento Federal na APS (Portaria 3.493) e maximizar os
          recursos federais destinados ao município.
        </p>
        <h1 class="titulo">1 APRESENTAÇÃO DE PROPOSTA COMERCIAL</h1>

        <p>
          Prezado(a) Gestor(a) Municipal de Saúde de
          <strong>{{ _nomeMunicipio }}</strong
          >, a gestão da saúde pública é desafiadora, tornando-se essencial
          adotar soluções inteligentes que otimizem a busca ativa, o
          monitoramento e a avaliação das ações e serviços ofertados nas
          Unidades Básicas de Saúde (UBS). A nossa proposta auxilia na
          conformidade com os requisitos do cofinanciamento federal da APS.
        </p>

        <p>
          Nesse contexto, apresentamos uma proposta inovadora e eficaz para
          Busca Ativa, Monitoramento e Avaliação na APS. Esta solução não apenas
          aprimorará a qualidade dos serviços prestados, mas também fornecerá
          dados valiosos para auxiliar na tomada de decisões estratégicas
          diárias pelos gestores e profissionais de saúde.
        </p>

        <p>
          A projeção é de que o município possa receber a mais ou deixar de
          receber até
          <b>
            R$
            {{
              resumoGanhoMensal.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })
            }}
          </b>
          no repasse mensal ou até
          <b>
            R$
            {{
              resumoGanhoAnual.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })
            }}
          </b>
          no repasse anual após o período de transição, especialmente a partir
          de setembro de 2026. Esse valor representa a diferença entre o
          desempenho <b>"ÓTIMO"</b>, que é o desejado, e o desempenho
          <b>"ATUAL"</b> que as equipes do município se encontram nos
          componentes de Qualidade e Vínculo e Acompanhamento Territorial
          (CVAT). A realização de Monitoramento e Avaliação (M & A) na APS
          torna-se indispensável para fazer busca ativa das pessoas e realizar
          monitoramento e avaliação dos indicadores. Com a realização de M & A
          na APS, é possível melhorar a assistência às pessoas e
          consequentemente os resultados dos indicadores e a classificação das
          equipes.
        </p>
      </div>
      <!-- end new page -->

      <!-- init new page -->
      <div class="new-page">
        <div class="row align-items-center">
          <div class="col-lg-12">
            <div class="resumo-equipes-simulacao">
              <div
                v-for="card in cardsRelatorio"
                :key="card.key"
                class="resumo-card"
                :class="card.key"
              >
                <div class="resumo-card__top"></div>

                <div class="resumo-card__body">
                  <h4>{{ card.title }}</h4>

                  <div
                    v-for="item in card.itens"
                    :key="`${card.key}-${item.label}`"
                    class="resumo-card__item"
                  >
                    <div class="resumo-card__info">
                      <span class="qtd">{{ item.quantidade }}</span>
                      <strong>{{ item.label }}</strong>
                    </div>

                    <span class="valor">
                      = {{ formatCurrency(item.valorTotal) }}
                    </span>
                  </div>

                  <div
                    v-if="!card.itens.length && card.key === 'otima'"
                    class="resumo-card__item resumo-card__item--empty"
                  >
                    <div class="resumo-card__info">
                      <strong>Nenhuma equipe no desempenho ótimo.</strong>
                    </div>
                  </div>

                  <div class="resumo-card__total">
                    <span>=</span>
                    <strong>{{ formatCurrency(card.total) }}</strong>
                  </div>

                  <div v-if="card.key !== 'otima'" class="simulador-perda">
                    <span>vs Ótimo</span>
                    <strong
                      >- {{ formatCurrency(perdaCardRelatorio(card)) }}</strong
                    >
                  </div>

                  <div v-else class="simulador-otimo">
                    <span>vs Ótimo</span>
                    <i class="icofont-trophy"></i>
                  </div>
                </div>
              </div>
            </div>

            <div class="simulador-resultado">
              <p>
                O município recebe atualmente
                <strong class="simulador-resultado__valor-atual">
                  {{ formatCurrency(totalReceberRelatorio) }}
                </strong>
                mensais, distribuídos entre os componentes
                <strong>Equidade</strong> ({{
                  formatCurrency(totalEquidadeRelatorio)
                }}), <strong>CVAT</strong> ({{
                  formatCurrency(totalCVATRelatorio)
                }}) e <strong>Qualidade</strong> ({{
                  formatCurrency(totalQualidadeRelatorio)
                }}). Com a melhoria da classificação de todas as equipes para
                ÓTIMO, o repasse mensal pode aumentar em mais
                <strong class="simulador-resultado__valor-ganho">
                  {{ formatCurrency(totalPerdaRelatorio) }}</strong
                >.
              </p>
            </div>

            <div class="simulador-resumo-progress">
              <div class="simulador-resumo-progress__row">
                <div class="simulador-resumo-progress__metric is-recebendo">
                  <div class="simulador-resumo-progress__content">
                    <span class="simulador-resumo-progress__label"
                      >Recebendo</span
                    >
                    <strong class="simulador-resumo-progress__value">
                      {{ formatCurrency(totalReceberRelatorio) }}
                    </strong>
                  </div>
                </div>

                <div class="simulador-resumo-progress__metric is-ganho">
                  <div class="simulador-resumo-progress__content">
                    <span class="simulador-resumo-progress__label">
                      Ganho potencial
                    </span>
                    <strong class="simulador-resumo-progress__value">
                      + {{ formatCurrency(totalPerdaRelatorio) }}
                    </strong>
                  </div>
                </div>

                <div class="simulador-resumo-progress__metric is-maximo">
                  <div class="simulador-resumo-progress__content">
                    <span class="simulador-resumo-progress__label">
                      Máximo possível
                    </span>
                    <strong class="simulador-resumo-progress__value">
                      = {{ formatCurrency(totalMaximoRelatorio) }}
                    </strong>
                  </div>
                </div>
              </div>

              <div
                class="simulador-resumo-progress__bar"
                :title="progressTitleRelatorio"
              >
                <div class="simulador-resumo-progress__track"></div>

                <div
                  class="simulador-resumo-progress__fill"
                  :style="{ width: `${progressPercentRelatorio}%` }"
                ></div>

                <div class="simulador-resumo-progress__caption">
                  {{ progressPercentRelatorio }}% do máximo
                </div>
              </div>
            </div>

            <p>
              Estamos confiantes de que esta proposta trará benefícios
              significativos para a gestão de saúde do município, elevando o
              padrão de atendimento e garantindo um uso mais eficiente dos
              recursos disponíveis na APS.
            </p>
          </div>
        </div>
      </div>
      <!-- end new page -->

      <!-- init new page -->
      <div
        v-if="this.$store.state.orcamento.pec_online === true"
        class="new-page"
      >
        <div class="row flex-column">
          <div class="imagem-header">
            <img
              v-if="$store.state.orcamento.empresa === 'biatic'"
              src="@/assets/images/biatic-colorido.png"
              class="logo"
              alt="biatic"
            />
            <img
              v-else
              src="@/assets/images/logo.png"
              class="logo"
              alt="esusfeedback"
            />
          </div>
        </div>
        <div class="pec-online">
          <h1 class="titulo">e-SUS PEC ONLINE</h1>
          <p>
            Colocar seu e-SUS PEC na nuvem para ser acessado via internet,
            estando disponivel 24 horas por dia, 7 dias por semana. Os
            benefícios são:
          </p>
          <ol class="lista-numerica" style="margin-left: 60px">
            <li>
              O backup é feito diariamente, automaticamente e disponibilizado
              para a Secretaria Municipal de Saúde. Com isso o município garante
              a segurança das informações e mantem os dados sempre em posse da
              gestão municipal;
            </li>
            <li>
              Envio de dados para o SISAB automático conforme processo de
              agendamento do e-SUS PEC. Como o servidor fica ligado 24 horas por
              dia, 7 dias por semana, então não corre o risco dos dados não
              serem processados;
            </li>
            <li>
              Atualização da última versão do e-SUS PEC em tempo oportuno para
              que o município e as equipes não percam as melhorias que estão
              sempre sendo lançadas;
            </li>
            <li>
              O acesso acontece por meio de link personalizado com o nome do
              município,
              <a :href="linkCidadeEstado" target="_blank">{{
                linkCidadeEstado
              }}</a
              >;
            </li>
            <li>
              A instalação dos e-SUS PEC em servidor online leva em consideração
              os requisitos mínimos do sistema disponibilizados pelo Ministério
              da Saúde;
            </li>
            <li>
              Os Agentes de Saúde que usam o e-SUS Território podem sincronizar
              seus dados de qualquer lugar que tenha internet e podem fazer isso
              todo dia. Assim, não correrá o risco de perder dados por passar
              uma semana sem sincronizar ou ter que sempre ir a um lugar fixo
              para realizar a sincronização. Essa ação contribui para a melhoria
              da Capitação Ponderada;
            </li>
            <li>
              Os demais aplicativos (e-SUS Atividade Coletiva, e-SUS AD, e-SUS
              Vacinação e Gestão e-SUS APS) podem ser sincronizados de qualquer
              lugar com acesso a internet. Isso facilita o trabalho e diminui as
              perdas de informação em virtude da dificuldade ou impossibilidade
              de sincronização dos dados desses aplicativos com o servidor e-SUS
              PEC;
            </li>
            <li>
              O Registro tardio de informações pode ser realizado de qualquer
              computador com acesso a internet. Isso aumenta a possibilidade
              para não perder registros de informações, uma vez que os
              profissionais da equipe não ficam dependentes apenas dos
              computadores de seu ambiente de trabalho para a digitação desses
              atendimentos. Isso contribui para melhorar os resultados do
              indicadores do Cofinanciamento federal 2024;
            </li>
            <li>
              Base de dados unificada, ou seja, um único cadastro por paciente e
              um único prontuário por paciente permite o cuidado continuado ao
              paciente e sua família, uma vez que ao comparecer a diversas UBS
              dentro do município, o cidadão ou cidadã não terá um cadastro e um
              prontuário em cada UBS, mas sim um Prontuário Eletrônico do
              Cidadão (PEC), onde todos os profissionais da APS poderam
              acompanhar o que foi realizado anteriormente e dar continuidade no
              cuidado ao cidadão ou cidadã. Isso acaba com o problema, por
              exemplo do médico da equipe A ao atender um cidadão não poder
              visualizar o seu histórico, pois os registros estão na equipe B;
            </li>
            <li class="quebrar-pagina">
              O PEC unificado também facilita diante da necessidade de entregar
              os registros impressos para os pacientes;
            </li>
            <li>
              É a garantia da unificação dos cadastros do cidadão ou cidadã, uma
              vez que a recomendação atual é registrar com o CPF e os
              profissionais não precisarão ficar atualizando um cadastro por
              UBS, mas sim o cadastro municipal;
            </li>
            <li>
              Colocar o e-SUS PEC online é sair da lógica de sistema da equipe
              para sistema do município, onde todas as equipes o acessam e fazem
              o cuidado continuado de todos os cidadãos e cidadãs assistidos no
              município
            </li>
          </ol>
          <p>
            Em suma, e-SUS PEC Online pode ser acessado de qualquer computador
            com acesso a internet, manter a segurança dos dados com backups em
            nuvem, unificar as bases de dados do e-SUS PEC que o município tem,
            manter o envio de dados sempre em dias, contribuir para a economia
            do município, uma vez que reduz custos com manutenção de servidores
            físicos (energia elétrica, refrigeração, recursos humanos para
            manutenção e software), melhorar os resultados do Cofinanciamento
            federal 2024, dentre outros.
          </p>
        </div>
      </div>
      <!-- end new page  -->

      <!-- init new page -->
      <div
        v-if="this.$store.state.orcamento.treinamento.ativo === true"
        class="new-page"
      >
        <div class="row flex-column">
          <div class="imagem-header">
            <img
              v-if="$store.state.orcamento.empresa === 'biatic'"
              src="@/assets/images/biatic-colorido.png"
              class="logo"
              alt="biatic"
            />
            <img
              v-else
              src="@/assets/images/logo.png"
              class="logo"
              alt="esusfeedback"
            />
          </div>
        </div>
        <div class="pec-online">
          <h1 class="titulo">
            TREINAMENTO e-SUS PEC/CDS {{ treinamentoUpper }}
          </h1>
          <p>
            O e-SUS Atenção Primária (e-SUS APS) tem o objetivo de reestruturar
            as informações da Atenção Primária de todo o Brasil. Sendo a
            qualificação da gestão da informação fundamental para ampliar a
            qualidade no atendimento à população, faz-se necessário realizar
            Educação Continuada e Educação Permanente para os profissionais de
            saúde visando qualificá-los para o correto Registro Clínico
            Eletrônico de dados em Saúde.
          </p>
          <p>O e-SUS APS está composto por diversos sistemas e aplicativos:</p>
          <ul style="margin-left: 45px">
            <li>• e-SUS PEC – Prontuário Eletrônico do Cidadão;</li>
            <li>• e-SUS Centralizador – Centralizador de Dados;</li>
            <li>
              • e-SUS PEC Centralizador – Prontuário Eletrônico do Cidadão e
              Centralizador;
            </li>
            <li>• e-SUS CDS – Sistema de Coleta Simplificada de Dados;</li>
            <li>• Aplicativo e-SUS APS Atividade Coletiva;</li>
            <li>• Aplicativo e-SUS APS Território;</li>
            <li>• Aplicativo e-SUS AD;</li>
            <li>• Aplicativo e-SUS Vacinação;</li>
            <li>• Aplicativo Gestão e-SUS APS.</li>
          </ul>

          <p>
            O treinamento é prático e individualizado, com os profissionais de
            saúde acessando o ambiente de treinamento e executando as
            atividades, enquanto o especialista os instrui sobre o correto uso
            das funcionalidades dos diversos recursos disponíveis.
          </p>
          <p>
            Como o e-SUS APS está organizado em perfis, de acordo a atuação de
            cada profissional de saúde na APS, o treinamento também se organiza
            dessa forma para utilizando-se de vídeoconferência e momentos
            presenciais (a depender da estratégia escolhida pelo gestor
            municipal de saúde.
          </p>
          <p>
            A capacitação envolve qualificar os profissionais que atuam na
            gestão e na assistênia à saúde, logo o treinamento está dividido da
            seguinte forma:
          </p>
          <ul style="margin-left: 45px">
            <li>
              • Treinamento e suporte no aplicativo e-SUS Atividade Coletiva
              para ações de Educação em Saúde, Programa Saúde na Escola,
              Academia de Saúde e outros;
            </li>
            <li>
              • Treinamento e suporte no perfil Agente de Saúde no aplicativo
              e-SUS Território ou similar bem como CDS para a qualificação dos
              dados no Cadastro Domiciliar e Territorial, Cadastro Individial
              (Capitação Ponderada) e Visita Domiciliar;
            </li>
            <li>• Treinamento e suporte na Administração do e-SUS PEC;</li>
            <li>
              • Treinamento e suporte perfis gestores (Secretário, Gerente de
              UBS e de APS) para analisar dados dos relatórios e-SUS PEC e
              aplicativo Gestão e-SUS APS;
            </li>
            <li class="quebrar-pagina">
              • Treinamento e suporte perfil sala de vacina (e-SUS PEC, CDS e
              Aplicativo e-SUS Vacinação);
            </li>
            <li>• Treinamento e suporte perfil médico;</li>
            <li>• Treinamento e suporte perfil odontólogo;</li>
            <li>• Treinamento e suporte perfil recepção;</li>
            <li>
              • Treinamento e suporte perfil técnico de enfermagem e saúde
              bucal;
            </li>
            <li>• Treinamento e suporte perfil enfermeiro;</li>
            <li>
              • Suporte Qualificação dos cadastros na APS por eliminação das
              inconsistências;
            </li>
            <li>
              • Suporte Unificação de prontuários duplicados no e-SUS AB PEC;
            </li>
          </ul>

          <p>
            As ações de Educação Permanente em Saúde na correta utilização da
            estratégia e-SUS APS leva em consideração todas as orientações do
            Ministério da Saúde para a qualificação dos dados, no que diz
            respeito aos requisitos do Programa Cofinanciamento federal 2024.
          </p>
        </div>
      </div>
      <!-- end new page -->

      <!-- init new page -->
      <div class="new-page">
        <div class="row flex-column">
          <div class="imagem-header">
            <img
              v-if="$store.state.orcamento.empresa === 'biatic'"
              src="@/assets/images/biatic-colorido.png"
              class="logo"
              alt="biatic"
            />
            <img
              v-else
              src="@/assets/images/logo.png"
              class="logo"
              alt="esusfeedback"
            />
          </div>
        </div>
        <h1 class="titulo">2 ESUS FEEDBACK</h1>
        <p>
          O eSUS Feedback
          <a
            href="https://esusfeedback.com.br/"
            target="_blank"
            class="proposta-link"
            >www.esusfeedback.com.br</a
          >
          é um app que atende as necessidades de modernização na Busca Ativa,
          Monitoramento e Avaliação de indicadores de saúde na APS, inclusive
          para acompanhar os componentes de Qualidade, CVAT e outros programas
          estratégicos, os quais fazem parte do Cofinanciamento federal da APS.
          Garantimos um nível de confiança de 97% nas informações e dados que
          apresentamos.
        </p>

        <h1 class="titulo" style="font-style: italic; font-weight: normal">
          O eSUS Feedback esteve recentemente presente em eventos importantes
          como:
        </h1>

        <ol class="lista-ol">
          <li>
            O Chamamento Público nº 01/2026 para integrar o Laboratório InovaSUS
            Digital sob coordenação da Secretaria de Informação e Saúde Digital
            do Ministério da Saúde;
          </li>
          <li>
            A 6ª Amostra Tocantinense (COSEMS TO), onde foi apresentada a
            experiência exitosa: SAÚDE DIGITAL NA GESTÃO DA APS: MONITORAMENTO
            ESTRATÉGICO DE INDICADORES EM COLINAS DO TOCANTINS-TO;
          </li>
          <li>
            A 11ª Mostra Piauí Aqui Tem SUS (COSEMS PI), onde foi apresentada:
            APLICABILIDADE DO E-SUS FEEDBACK NO MONITORAMENTO DE INDICADORES DA
            ATENÇÃO PRIMÁRIA À SAÚDE;
          </li>
          <li>
            Mais experiências de uso científico, podem ser encontradas no link
            <a
              href="https://www.esusfeedback.com.br/uso-cientifico"
              target="_blank"
              >esusfeedback.com.br/uso-cientifico</a
            >
          </li>
        </ol>

        <h1 class="titulo" style="font-style: italic; font-weight: normal">
          O eSUS Feedback apresenta as seguintes funcionalidades e requisitos:
        </h1>
        <ol class="lista-ol">
          <li>
            Pode ser executado e/ou acessado em smartphones com Android, Iphone
            ou computadores com navegador atualizado e acesso à internet;
          </li>
          <li>
            Os profissionais de saúde e gestores podem consultar e visualizar
            cidadãos e seus atendimentos, desde que eles estejam sob seus
            cuidados;
          </li>
          <li>
            Permite o monitoramento dos cadastros individuais por Agente de
            Saúde;
          </li>
          <li>
            Possibilita o acompanhamento das pessoas visitadas por Agente de
            Saúde;
          </li>
          <li>
            Tem capacidade para o monitoramento e avaliação dos resultados dos
            indicadores de saúde na APS estratificado por município, equipe e
            microárea;
          </li>
          <li>
            Auxilia gestores e profissionais de saúde no monitoramento e
            avaliação das ações de saúde no território;
          </li>
          <li>
            Disponibiliza painel de gestão que pode ser acessado pelas
            principais tecnologias (computador, smartphone/iphone) utilizando o
            sistema operacional Linux, Windows, MAC OS, IOS ou Android com
            navegador de internet atualizado;
          </li>
          <li class="quebrar-pagina">
            Permite a identificação dos cadastros duplicados de cidadãos dentro
            do e-SUS PEC ou Centralizador;
          </li>
          <li>
            Mostra os cidadãos não vinculados às equipes de APS dentro do e-SUS
            PEC ou Centralizador;
          </li>
          <li>
            Lista os cidadãos não vinculados aos Agentes de Saúde dentro do
            e-SUS PEC ou Centralizador;
          </li>
          <li>
            Identifica os cidadãos com possível CNS inválido ou com falta de CPF
            no Cadastro Individual (Ficha completa e Ficha reduzida);
          </li>
          <li>
            Monitora o envio de dados pelo registro das Visitas Domiciliares dos
            Agentes de Saúde para o sistema e-SUS PEC ou Centralizador;
          </li>
          <li>
            Cruza os dados dos profissionais de saúde cadastrados no e-SUS PEC
            ou Centralizador e SCNES para que os dados dos atendimentos na APS
            sejam validados e enviados com sucesso para o sistema SISAB do
            Ministério da Saúde;
          </li>
          <li>Identifica os cidadãos que estão com vacinas atrasadas;</li>
          <li>
            Permite aos gestores e profissionais de saúde acompanharem os
            atendimentos realizados na APS por data e turno nos últimos 90 dias;
          </li>
          <li>
            Tem capacidade para mediar a busca ativa em relação aos diversos
            tipos de serviços disponíveis na APS facilitando a comunicação entre
            gestores e profissionais de saúde das equipes;
          </li>
          <li>
            Possibilidade a comunicação de dados e informações entre os gestores
            e os profissionais das equipes de saúde, entre os profissionais da
            própria equipe, inclusive os Agentes de Saúde;
          </li>
          <li>
            Integra-se com o sistema e-SUS PEC ou Centralizador para a
            importação dos dados já cadastrados, os quais são necessários à
            geração da informação que é disponibilizada;
          </li>
          <li>
            Tem ajuda audiovisual por perfil cadastrado explicando sobre a
            interpretação dos dados que estão em exibição, bem como a resolução
            de problemas dentro do e-SUS PEC ou Centralizador;
          </li>
          <li>
            Permite buscas personalizadas para encontrar informações relevantes
            à tomada de decisão;
          </li>
          <li>
            Pode ser utilizado em qualquer cenário de informatização da APS que
            o município esteja fazendo uso, inclusive consegue ler dados
            enviados a partir de sistemas próprios ou sistemas de terceiros.
          </li>
        </ol>
      </div>
      <!-- end new page  -->

      <!-- init new page -->
      <div class="new-page">
        <h1 class="titulo">2.1 SIAPS e PEC</h1>
        <p>
          O Sistema de Informação da Atenção Primária à Saúde (SIAPS), apresenta
          resultados tardios em relação às ações em desenvolvimento no
          município, ou seja, quando não é mais possível, em muitos casos,
          realizar medidas para evitar as perdas de recursos. Cumpre ainda
          destacar que o SIAPS, em razão da quantidade de acessos, fica, por
          muitas vezes, indisponível em horário comercial.
        </p>

        <p>
          O Prontuário Eletrônico do Cidadão, e-SUS PEC ou Centralizador não
          traz resposta em tempo oportuno para as principais perguntas dos
          gestores e profissionais de saúde a respeito do vínculo,
          acompanhamento e o componente de qualidade, bem como visitas
          domiciliares e outras ações que são requisitos do cofinanciamento
          federal da APS.
        </p>

        <p>
          São muitas perguntas a serem respondidas diariamente com o objetivo de
          apresentar resumos e resultados quantitativos e qualitativos que podem
          ajudar profissionais de saúde e gestores municipais na tomada de
          decisão.
        </p>

        <h1 class="titulo">2.2 Teste o eSUS Feedback</h1>

        <p>
          <strong>
            Nós, que trabalhamos com análise de dados em saúde, estamos
            oferecendo a você a oportunidade de testar o app eSUS Feedback,
            juntamente com ou sem uma assessoria especializada em Tecnologia da
            Informação e Comunicação em Saúde como estratégia para maximizar o
            recebimento de recursos federais para a APS municipal no
            Cofinanciamento federal da APS.</strong
          >
        </p>

        <p>
          Você pode receber uma demonstração e testar o eSUS Feedback por 30
          dias sem custo para a gestão municipal.
        </p>
      </div>
      <!-- end new page -->

      <!-- init new page -->
      <div class="new-page">
        <div class="imagem-header">
          <img
            v-if="$store.state.orcamento.empresa === 'biatic'"
            src="@/assets/images/biatic-colorido.png"
            class="logo"
            alt="biatic"
          />
          <img
            v-else
            src="@/assets/images/logo.png"
            class="logo"
            alt="esusfeedback"
          />
        </div>
        <!-- MONITORAMENTO E AVALIAÇÃO NA APS -->
        <div v-if="$store.state.orcamento.mea_na_aps === true">
          <h1 class="titulo">MONITORAMENTO E AVALIAÇÃO NA APS</h1>
          <p>
            O Programa Cofinanciamento federal 2024 estabeleceu regras,
            normativas e requisitos, a serem atendidos, os quais são necessários
            para os municípios receberem 100% dos repasses federais na APS. Para
            atender a esses requisitos, faz-se necessário Monitorar e Avaliar a
            situação da oferta das Ações e Serviços de Saúde, bem como os
            resultados atuais. De acordo com William Edwards Deming, que é
            considerado o pai da gestão da qualidade,
            <i
              >“Não se gerencia o que não se mede, não se mede o que não se
              define e não se define o que não se entende, ou seja,
              <strong
                >não há sucesso no que não se monitora, avalia, intervém e
                gerencia</strong
              >”</i
            >.
          </p>
          <p>
            O Monitoramento e Avaliação na Atenção Primária à Saúde
            <strong>(M & A na APS)</strong> historicamente sempre foi difícil de
            ser praticado por falta de informações sempre atualizadas e
            disponíveis no momento da sua necessidade. Também faltavam metas
            claras e transparentes que expressassem os desafios a serem vencidos
            para alcançar os objetivos. Outras dificuldades eram estabelecer
            indicadores com parâmetros que permitissem identificar, mensurar,
            acompanhar e comunicar, de forma simples, a evolução de determinado
            aspecto da intervenção proposta nas metas com apuração periódica e
            possibilidade de avaliação e intervenção.
          </p>
          <p>
            A maioria dos supramencionados desafios foram vencidos e viraram
            requisitos a serem atendidos no Programa Cofinanciamento federal
            2024, mas os municípios ainda não conseguem realizar
            <strong>M & A na APS</strong> de forma integrada ao processo de
            trabalho dos profissionais das equipes de saúde da APS municipal. A
            proposta de <strong>M & A na APS</strong> consistem em:
          </p>

          <ol style="list-style: auto; margin-left: 60px">
            <li>
              Realizar treinamento inicial sobre M & A na APS por equipe para os
              profissionais de saúde;
            </li>
            <li>
              Entregar informação em tempo oportuno para as equipes de saúde,
              individualmente, e ofertar feedback sobre as principais dúvidas no
              processo de qualificação dos dados no que diz respeito ao registro
              clínico em Prontuário Eletrônico do Cidadão;
            </li>
            <li>
              Reunir-se regularmente (uma vez por mês) com cada equipe de saúde
              municipal para discutir os principais problemas da qualificação da
              informação e outros pertinentes ao processo de trabalho;
            </li>
            <li>
              Reunir-se regularmente (a critério da gestão) com os gestores
              municipais para prestar esclarecimentos sobre dúvidas envolvendo
              os resultados atuais com base nos indicadores e metas
              estabelecidos;
            </li>
            <li>
              Realizar regulamente (uma vez por mês) por equipe um processo de
              interpretação dos dados para identificar oportunidade de busca
              ativa e solucionar os problemas que os profissionais por si só
              ainda não conseguiram resolver;
            </li>
            <li>
              Atender eletronicamente (WhatsApp, telefone ou videoconferência) a
              chamados que precisam de apoio técnico na solução de problemas
              envolvendo a qualificação de dados em saúde.
            </li>
          </ol>

          <p class="quebrar-pagina">
            A realização de <strong>M & A na APS</strong> integrado ao processo
            de trabalho das equipes (Medicina, Enfermagem, Odontologia,
            Recepcionistas, Vacinadores, Agentes Comunitários de Saúde e outros)
            tem-se mostrado eficiente nas experiências praticadas, pois
            personaliza e individualiza o apoio técnico de acordo com as
            necessidades dos profissionais e diante dos problemas que eles
            apresentam. Com esse processo, permite-se sair da teoria e dos
            momentos expositivos dialogados (que tem caráter mais informacional)
            para treinamento prático e mais imersivo (que tem mais capacidade de
            gerar aprendizagem).
          </p>
        </div>
        <!-- plano de trabalho -->
        <div
          v-else-if="$store.state.orcamento.primeiraContratacao === 'primeira'"
        >
          <h1 class="titulo">3 PLANO DE TRABALHO</h1>
          <p>
            Após a decisão municipal de utilização do app eSUS Feedback, que
            acontece pela criação do perfil de Secretário(a) Municipal de Saúde
            na página inicial da plataforma
            <a
              href="https://esusfeedback.com.br/login"
              target="_blank"
              class="proposta-link"
              >https://esusfeedback.com.br/login</a
            >, a gestão municipal pode usar o eSUS Feedback por 30 (trinta)
            dias, um período de avaliação. A partir dos 20 (vinte) dias da data
            de implantação do período de teste e apresentação, entramos em
            contato com representantes da gestão municipal para dar andamento a
            uma possível parceria.
          </p>
          <p>
            Caso o município tenha interesse em continuar utilizando a
            plataforma, então assina-se o contrato entre as partes e iniciam-se
            os treinamentos. Se o município não desejar continuar utilizando o
            eSUS Feedback, então todos os dados relacionados ao município são
            deletados no servidor do eSUS Feedback.
          </p>
          <p>Em suma, essa proposta inclui:</p>
          <p>
            1. Antes da assinatura do contrato e sob responsabilidade da
            contratada:
          </p>
          <ul class="lista-sem-marcacao-2">
            <li>
              a. Instalação do eSUS Feedback para ser acessado por todos ou
              alguns profissionais de saúde e gestores da Atenção Primária à
              Saúde;
            </li>
            <li>
              b. Período de avaliação de 30 dias, sem custo, para testar as
              funcionalidades da ferramenta;
            </li>
            <li>
              c. Apresentação do eSUS Feedback no período de avaliação para
              profissionais de nível superior, gestão, coordenação e Tecnologia
              da Informação (TI) do município;
            </li>
          </ul>

          <p>
            2. Após a assinatura do contrato e sob solicitação expressa da
            contratante:
          </p>
          <ul class="lista-sem-marcacao-2">
            <li>
              a. Treinamento no Cofinanciamento federal 2024 por equipe de saúde
              do município (Enfermagem, Medicina Odontologia, Recepcionistas,
              Agentes de Saúde e gestores municipais);
            </li>
            <li>
              b. 30 dias depois do treinamento inicial, acompanhamento para
              tirar dúvidas dos profissionais por equipe;
            </li>
            <li>
              c. Quadrimestralmente, reunião por equipe para comunicar os
              resultados do quadrimestre e trabalhar o eSUS Feedback para as
              buscas ativas;
            </li>
            <li>
              d. Suporte contínuo (WhatsApp, chat online e Videoconferência pelo
              google meet) agendadas previamente.
            </li>
          </ul>
        </div>
        <div
          v-else-if="$store.state.orcamento.primeiraContratacao === 'renovacao'"
        >
          <h1 class="titulo">3 PLANO DE TRABALHO</h1>
          <p>
            Após a decisão municipal de continuar utilizando o app eSUS
            Feedback, assina-se o contrato entre as partes e continua-se o
            suporte e treinamento, quando solicitados. Se o município não
            desejar continuar utilizando o eSUS Feedback, então todos os dados
            relacionados são deletados no servidor do eSUS Feedback.
          </p>
          <p>Está incluso no suporte:</p>
          <ul class="lista-sem-marcacao-2" style="margin-left: 52px !important">
            <li>
              • Quadrimestralmente, reunião por equipe** ou com a gestão
              municipal para comunicar os resultados do quadrimestre e trabalhar
              o eSUS Feedback para as buscas ativas e o monitoramento e
              avaliação na APS;
            </li>
            <li>
              • Suporte contínuo (WhatsApp, chat online e Videoconferência pelo
              google meet) agendadas previamente.
            </li>
          </ul>
        </div>
        <!-- Fim plano de trabalho -->
      </div>
      <!-- end new page  -->

      <!-- init new page  -->
      <div class="new-page">
        <div class="row flex-column">
          <div class="imagem-header">
            <img
              v-if="$store.state.orcamento.empresa === 'biatic'"
              src="@/assets/images/biatic-colorido.png"
              class="logo"
              alt="biatic"
            />
            <img
              v-else
              src="@/assets/images/logo.png"
              class="logo"
              alt="esusfeedback"
            />
          </div>
        </div>
        <h1 class="titulo">4 PROPOSTA DE PREÇO DOS SERVIÇOS</h1>
        <p>
          Esta proposta leva em consideração que o município de
          <span class="variaveis">
            {{ $store.state.orcamento.cidade }} –
            {{ $store.state.orcamento.estado }}</span
          >
          possui
          <span class="variaveis"
            >{{ $store.state.orcamento.total_equipe }} ({{
              numero_extenso
            }})</span
          >
          equipes de saúde entre eSF e eAP e pretende contratar os serviços
          descritos na tabela abaixo por período de
          {{ $store.state.orcamento.quantidade_meses }} meses com início em data
          a ser combinada entre as partes.
        </p>
        <table class="tabela">
          <thead>
            <tr>
              <th>SERVIÇOS</th>
              <th>*PARCELAS</th>
              <th>**EQUIPES</th>
              <th>V. POR EQUIPE</th>
              <th>VALOR MENSAL</th>
              <th>VALOR TOTAL</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>eSUS Feedback</td>
              <td
                v-if="this.$store.state.orcamento.parcelaImplantacao === true"
              >
                {{ parcelaImplantacao }} +
                {{ $store.state.orcamento.quantidade_meses }}
              </td>
              <td v-else>{{ $store.state.orcamento.quantidade_meses }}</td>

              <td>{{ $store.state.orcamento.total_equipe }}</td>
              <td>
                <span>R$</span
                ><span>{{ valorEquipePorFaixaEsusFeedback }}</span>
              </td>
              <td>
                <span>R$</span><span>{{ valorMensalEsusFeedback }}</span>
              </td>
              <td>
                <span>R$</span><span>{{ valorAnualEsusFeedback }}</span>
              </td>
            </tr>
            <tr v-if="$store.state.orcamento.mea_na_aps === true">
              <td>M & A na APS</td>
              <td>
                {{
                  parseInt($store.state.orcamento.quantidade_meses) +
                  parcelaImplantacao
                }}
              </td>
              <td>{{ $store.state.orcamento.total_equipe }}</td>
              <td>
                <span>R$</span
                ><span>{{ valorEquipePorFaixaEsusFeedback }}</span>
              </td>
              <td>
                <span>R$</span><span>{{ valorMensalEsusFeedback }}</span>
              </td>
              <td>
                <span>R$</span><span>{{ valorAnualEsusFeedback }}</span>
              </td>
            </tr>
            <tr v-else>
              <td>Plano de trabalho</td>
              <td>
                {{
                  parseInt($store.state.orcamento.quantidade_meses) +
                  parcelaImplantacao
                }}
              </td>
              <td>{{ $store.state.orcamento.total_equipe }}</td>
              <td><span>R$</span><span>00,00</span></td>
              <td><span>R$</span><span>00,00</span></td>
              <td><span>R$</span><span>00,00</span></td>
            </tr>
            <tr v-if="this.$store.state.orcamento.pec_online === true">
              <td>e-SUS Pec online</td>
              <td>
                {{
                  parseInt($store.state.orcamento.quantidade_meses) +
                  parcelaImplantacao
                }}
              </td>
              <td>{{ $store.state.orcamento.total_equipe }}</td>
              <td>
                <span>R$</span><span>{{ valorEquipeVezesFaixaPecOnline }}</span>
              </td>
              <td>
                <span>R$</span><span>{{ valorMensalPecOnline }}</span>
              </td>
              <td>
                <span>R$</span><span>{{ valorAnualPecOnline }}</span>
              </td>
            </tr>
            <tr v-if="this.$store.state.orcamento.treinamento.ativo === true">
              <td>
                EPS e-SUS PEC/CDS
                {{ this.$store.state.orcamento.treinamento.tipo }}
              </td>
              <td>
                {{
                  parseInt($store.state.orcamento.quantidade_meses) +
                  parcelaImplantacao
                }}
              </td>
              <td>{{ $store.state.orcamento.total_equipe }}</td>
              <td>
                <span>R$</span><span>{{ valorTreinamentoPorEquipe }}</span>
              </td>
              <td>
                <span>R$</span><span>{{ valorTreinamentoMensal }}</span>
              </td>
              <td>
                <span>R$</span><span>{{ valorTreinamentoAnual }}</span>
              </td>
            </tr>
            <tr>
              <td>Total do contrato</td>
              <td>
                {{
                  parseInt($store.state.orcamento.quantidade_meses) +
                  parcelaImplantacao
                }}
              </td>
              <td>{{ $store.state.orcamento.total_equipe }}</td>
              <td>
                <span>R$</span><span>{{ valorTotalPorEquipe }}</span>
              </td>
              <td>
                <span>R$</span><span>{{ valorTotalMensal }}</span>
              </td>
              <td>
                <span>R$</span><span>{{ valorTotalAnual }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <p>
          * A 1ª parcela é faturada com a implantação do(s) serviço(s). Ela visa
          cobrir custos que se tem para iniciar a oferta do(s) serviço(s). As
          demais parcelas referem-se a licença para uso dos serviços propostos.
        </p>
        <p>
          ** Até 6 equipes por município, o plano de trabalho, suporte e apoio
          no uso do eSUS Feedback pode ser realizado direto com os profissionais
          de saúde das equipes, um técnico responsável pelos Agentes de Saúde e
          equipe gestora. A partir de 7 equipes por município, o plano de
          trabalho, suporte e apoio no uso do eSUS Feedback é realizado para a
          equipe gestora municipal que multiplica, ou seja, conduz com os
          profissionais.
        </p>
        <p style="margin-top: 0px; margin-bottom: 20px">
          Essa proposta de prestação de serviço tem validade de 60 dias a contar
          da data deste documento.
        </p>
        <p>Ibiara – PB, {{ _dataQueOUsuarioEscolheu }}.</p>

        <p class="atenciosamente" style="margin-top: 10px; margin-bottom: 20px">
          Atenciosamente,
        </p>
        <p v-if="$store.state.orcamento.empresa === 'biatic'">
          <span class="texto-negrito"
            >BIATIC ASSESSORIA EM TECNOLOGIA DA INFORMAÇÃO E COMUNICAÇÃO EM
            SAÚDE</span
          >, sociedade empresárial, com sede na Rua João Ciriaco, 251,
          Ibiarinha, Ibiara-PB, CEP nº 58.980-000, inscrita no CNPJ/MF sob nº
          27.197.452/0001-61.
        </p>
        <p v-else>
          <span class="texto-negrito"
            >ESUS FEEDBACK CONSULTORIA E SERVICOS LTDA</span
          >, sociedade empresarial, com sede na Rua Antônio Ferreira Ramalho, nº
          43, Sala 101, Ibiarinha, Ibiara - PB, CEP nº 58980-000, inscrita no
          CNPJ/MF sob nº 45.180.436/0001-48.
        </p>
        <div class="footer">
          <span v-if="$store.state.orcamento.empresa === 'biatic'"
            >E-mail
            <a href="mailto:contato@biatic.com.br" class="proposta-link"
              >contato@biatic.com.br</a
            ></span
          >
          <span v-else
            >E-mail
            <a href="mailto:contato@esusfeedback.com.br" class="proposta-link"
              >contato@esusfeedback.com.br</a
            ></span
          >

          <span
            >Instagram
            <a
              href="https://www.instagram.com/biatic"
              target="_blank"
              class="proposta-link"
              >https://www.instagram.com/biatic</a
            ></span
          >
          <span
            >YouTube
            <a
              href="https://www.youtube.com/c/esusfeedback"
              target="_blank"
              class="proposta-link"
              >https://www.youtube.com/c/esusfeedback</a
            ></span
          >
          <span
            >Contato/Whatsapp /
            <a
              href="http://api.whatsapp.com/send?1=pt_BR&phone=5583981347977"
              target="_blank"
              class="proposta-link"
              >9 98134-7977</a
            ></span
          >
        </div>
        <div class="topo">
          <b-button type="button" variant="primary" @click="topo()"
            ><i class="icofont-arrow-up"></i>Topo</b-button
          >
        </div>
      </div>
      <!-- end new page  -->
    </div>
  </div>
</template>

<script>
import TabelaDescricao from '@/pages/CofinanciamentoSimulacao/components/TabelaDescricao.vue'
import TabelaPorcentagem from '@/pages/CofinanciamentoSimulacao/components/TabelaPorcentagem.vue'
import {
  regras,
  getLabelRegra,
} from '@/pages/CofinanciamentoSimulacao/utils.js'
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'Proposta',
  components: {
    TabelaDescricao,
    apexchart: VueApexCharts,
    TabelaPorcentagem,
  },
  data() {
    return {
      numero_extenso: '',
      capitacao_ponderada: 0,
      fixo: {
        implantacao: '',
        custeio: '',
        valorImplantacao: 0,
        valorCusteio: 0,
      },
      vinculo_e_acompanhamento: [
        {
          classificacao: 'Ótimo',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Bom',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Suficiente',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Regular',
          text: '',
          valorTotal: 0,
        },
      ],
      qualidade: [
        {
          classificacao: 'Ótimo',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Bom',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Suficiente',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Regular',
          text: '',
          valorTotal: 0,
        },
      ],
      previne_brasil: {
        capitacaoPonderada: 0,
        pagamentoDesempenho: 0,
        informatizaAps: 0,
        indicadoresSaudeBucal: 0,
        indicadoresSaudeNaHora: 0,
        pagamentoCriterioPopulacional: 0,
      },
      perCapita: 0,
      perCapitaTotal: 0,
      dadosTabelaPorcentagem: [],
      showModal: false,
      loadingBtnSalvarSugestao: false,
      form: {
        sugestao: '',
      },
      chartPieSeriesRegular: [],
      chartPieSeriesSuficiente: [],
      chartPieSeriesBom: [],
      chartPieSeriesOtimo: [],
      chartPieOptions: {
        chart: {
          width: 380,
          type: 'pie',
        },
        labels: [
          'Fixo Implantação',
          'Fixo de custeio',
          'Qualidade',
          'Vínculo e acompanhamento',
          'Per capita',
        ],
        colors: ['#156082', '#E97132', '#196B24', '#0F9ED5', '#A02B93'],
        legend: {
          position: 'bottom',
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 350,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      },
      chartSeriesTabelaPorcentagem: [],
      chartSeriesTabelaPorcentagemAnual: [],
      chartBarOptions: {
        xaxis: {
          categories: ['Ótimo', 'Bom', 'Suficiente', 'Regular'],
        },
        yaxis: {
          labels: {
            formatter: (val) => {
              return (
                'R$ ' +
                val.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              )
            },
          },
        },
        colors: ['#22B14C', '#FFF200', '#FF7F27', '#ED1C24'],
        plotOptions: {
          bar: {
            columnWidth: '65%',
            distributed: true,
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return (
              'R$ ' +
              val.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })
            )
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#304758'],
          },
        },
        legend: {
          show: false,
        },
      },
      regras: regras,
      textoTabelaPorcentagem: '',
      texto2TabelaPorcentagem: '',
      texto3TabelaPorcentagem: '',
      showSidebarMenu: false,
      diferencaMensalOtimoRegular: 0,
      diferencaAnualOtimoRegular: 0,
    }
  },
  mounted() {
    const writtenNumber = require('written-number')
    writtenNumber.defaults.lang = 'pt'
    this.numero_extenso = writtenNumber(
      this.$store.state.orcamento.total_equipe
    )

    this.preencherRelatorio()
  },
  computed: {
    /**
     * Retorna o nome completo do município e estado
     *
     * @returns {string}
     */
    _nomeMunicipio() {
      return (
        this.$store.state.orcamento.cidade +
        ' – ' +
        this.$store.state.orcamento.estado
      )
    },

    /**
     * Retorna a fonte formatada com mês e ano atual
     *
     * @returns {string}
     */
    _fonte() {
      let dataAtual = new Date()

      let nomesMeses = [
        'janeiro',
        'fevereiro',
        'março',
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro',
      ]

      let mesAtual = nomesMeses[dataAtual.getMonth()]

      let anoAtual = dataAtual.getFullYear()

      let mesAnoFormatado = mesAtual + '/' + anoAtual
      return `<b>Fonte</b>: Autoria própria, ${mesAnoFormatado}`
    },

    /**
     * Retorna a data escolhida pelo usuário formatada por extenso
     *
     * @returns {string}
     */
    _dataQueOUsuarioEscolheu() {
      const dia = this.$store.state.orcamento.data_inicio.split('/')[0]
      const mes = this.$store.state.orcamento.data_inicio.split('/')[1]

      let mesExtenso = ''
      switch (mes) {
        case '01':
          mesExtenso = 'janeiro'
          break
        case '02':
          mesExtenso = 'fevereiro'
          break
        case '03':
          mesExtenso = 'março'
          break
        case '04':
          mesExtenso = 'abril'
          break
        case '05':
          mesExtenso = 'maio'
          break
        case '06':
          mesExtenso = 'junho'
          break
        case '07':
          mesExtenso = 'julho'
          break
        case '08':
          mesExtenso = 'agosto'
          break
        case '09':
          mesExtenso = 'setembro'
          break
        case '10':
          mesExtenso = 'outubro'
          break
        case '11':
          mesExtenso = 'novembro'
          break
        case '12':
          mesExtenso = 'dezembro'
          break
      }

      const ano = this.$store.state.orcamento.data_inicio.split('/')[2]
      return `${dia} de ${mesExtenso} de ${ano}`
    },

    /**
     * Retorna a quantidade de parcelas de implantação
     *
     * @returns {number}
     */
    parcelaImplantacao() {
      if (this.$store.state.orcamento.parcelaImplantacao === true) {
        return 1
      }
      return 0
    },

    /**
     * Retorna o tipo de treinamento em letras maiúsculas
     *
     * @returns {string}
     */
    treinamentoUpper() {
      return this.$store.state.orcamento.treinamento.tipo.toUpperCase()
    },

    /**
     * Retorna o link personalizado do e-SUS PEC Online
     *
     * @returns {string}
     */
    linkCidadeEstado() {
      this.$store.state.orcamento

      return `${this.$store.state.orcamento.cidade.toLowerCase()}${this.$store.state.orcamento.estado.toLowerCase()}.com.br`
    },

    /**
     * Retorna o valor da equipe por faixa do eSUS Feedback
     *
     * @returns {string}
     */
    valorEquipePorFaixaEsusFeedback() {
      let valor = this.$store.state.orcamento.faixa_preco

      if (this.$store.state.orcamento.acrescimo === true) {
        valor = valor + valor * 0.06
      }
      return valor
        .toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
        .replace('R$', '')
    },

    /**
     * Retorna o valor mensal do eSUS Feedback
     *
     * @returns {string}
     */
    valorMensalEsusFeedback() {
      let faixa_preco = this.$store.state.orcamento.faixa_preco
      if (this.$store.state.orcamento.acrescimo === true) {
        faixa_preco = faixa_preco + faixa_preco * 0.06
      }
      const valor = this.$store.state.orcamento.total_equipe * faixa_preco
      return valor
        .toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
        .replace('R$', '')
    },

    /**
     * Retorna o valor total do eSUS Feedback
     *
     * @returns {string}
     */
    valorAnualEsusFeedback() {
      let faixa_preco = this.$store.state.orcamento.faixa_preco
      if (this.$store.state.orcamento.acrescimo === true) {
        faixa_preco = faixa_preco + faixa_preco * 0.06
      }
      const valorMes = this.$store.state.orcamento.total_equipe * faixa_preco
      const valorAno =
        valorMes *
        (this.$store.state.orcamento.quantidade_meses + this.parcelaImplantacao)
      return valorAno
        .toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
        .replace('R$', '')
    },

    /**
     * Retorna o valor da equipe por faixa do e-SUS PEC Online
     *
     * @returns {string}
     */
    valorEquipeVezesFaixaPecOnline() {
      const valor =
        this.$store.state.orcamento.faixa_preco_pec_online /
        this.$store.state.orcamento.total_equipe
      return valor
        .toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
        .replace('R$', '')
    },

    /**
     * Retorna o valor mensal do e-SUS PEC Online
     *
     * @returns {string}
     */
    valorMensalPecOnline() {
      const valor = this.$store.state.orcamento.faixa_preco_pec_online
      return valor
        .toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
        .replace('R$', '')
    },

    /**
     * Retorna o valor total do e-SUS PEC Online
     *
     * @returns {string}
     */
    valorAnualPecOnline() {
      const valorMes = this.$store.state.orcamento.faixa_preco_pec_online
      const valorAno =
        valorMes *
        (this.$store.state.orcamento.quantidade_meses + this.parcelaImplantacao)
      return valorAno
        .toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
        .replace('R$', '')
    },

    /**
     * Retorna o valor do treinamento por equipe
     *   Online 500 Reais
     *   Presencial 1200 Reais
     * @returns {string}
     */

    valorTreinamentoPorEquipe() {
      if (
        this.$store.state.orcamento.treinamento.tipo.toLowerCase() === 'online'
      ) {
        let valor = 500.0
        return valor
          .toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
          })
          .replace('R$', '')
      }
      if (
        this.$store.state.orcamento.treinamento.tipo.toLowerCase() ===
        'presencial'
      ) {
        let valor = 1200.0
        return valor
          .toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
          })
          .replace('R$', '')
      }
      return ''
    },

    /**
     * Retorna o valor mensal do treinamento
     *
     * @returns {string}
     */
    valorTreinamentoMensal() {
      let valor =
        this.computedEmNumero(this.valorTreinamentoPorEquipe) *
        this.$store.state.orcamento.total_equipe
      return valor
        .toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
        .replace('R$', '')
    },

    /**
     * Retorna o valor total do treinamento
     *
     * @returns {string}
     */
    valorTreinamentoAnual() {
      let valor =
        this.computedEmNumero(this.valorTreinamentoMensal) *
        (this.$store.state.orcamento.quantidade_meses + this.parcelaImplantacao)
      return valor
        .toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
        .replace('R$', '')
    },

    /**
     * Retorna o valor total por equipe
     *
     * @returns {string}
     */
    valorTotalPorEquipe() {
      /* Apenas esus feedback */
      let valor = null
      if (
        this.$store.state.orcamento.pec_online === false &&
        this.$store.state.orcamento.treinamento.ativo === false
      ) {
        valor = this.computedEmNumero(this.valorEquipePorFaixaEsusFeedback)
      }
      /* Com esus feedback + pec online */
      if (
        this.$store.state.orcamento.pec_online === true &&
        this.$store.state.orcamento.treinamento.ativo === false
      ) {
        valor =
          this.computedEmNumero(this.valorEquipePorFaixaEsusFeedback) +
          this.computedEmNumero(this.valorEquipeVezesFaixaPecOnline)
      }
      /* Com esus feedback + treinamento */
      if (
        this.$store.state.orcamento.pec_online === false &&
        this.$store.state.orcamento.treinamento.ativo === true
      ) {
        valor =
          this.computedEmNumero(this.valorEquipePorFaixaEsusFeedback) +
          this.computedEmNumero(this.valorTreinamentoPorEquipe)
      }
      /* Com esus feedback + pec online + treinamento */
      if (
        this.$store.state.orcamento.pec_online === true &&
        this.$store.state.orcamento.treinamento.ativo === true
      ) {
        valor =
          this.computedEmNumero(this.valorEquipePorFaixaEsusFeedback) +
          this.computedEmNumero(this.valorEquipeVezesFaixaPecOnline) +
          this.computedEmNumero(this.valorTreinamentoPorEquipe)
      }
      if (this.$store.state.orcamento.mea_na_aps === true) {
        valor =
          valor + this.computedEmNumero(this.valorEquipePorFaixaEsusFeedback)
      }
      return valor
        .toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
        .replace('R$', '')
    },

    /**
     * Retorna o valor total mensal do contrato
     *
     * @returns {string}
     */
    valorTotalMensal() {
      let valorTotal = null
      /* Apenas esus feedback */
      if (
        this.$store.state.orcamento.pec_online === false &&
        this.$store.state.orcamento.treinamento.ativo === false
      ) {
        const valorFeddback =
          this.$store.state.orcamento.total_equipe *
          this.computedEmNumero(this.valorEquipePorFaixaEsusFeedback)
        valorTotal = valorFeddback + 0
      }
      /* Com esus feedback + pec online */
      if (
        this.$store.state.orcamento.pec_online === true &&
        this.$store.state.orcamento.treinamento.ativo === false
      ) {
        valorTotal =
          this.computedEmNumero(this.valorMensalEsusFeedback) +
          this.computedEmNumero(this.valorMensalPecOnline)
      }
      /* Com esus feedback + treinamento */
      if (
        this.$store.state.orcamento.pec_online === false &&
        this.$store.state.orcamento.treinamento.ativo === true
      ) {
        valorTotal =
          this.computedEmNumero(this.valorMensalEsusFeedback) +
          this.computedEmNumero(this.valorTreinamentoMensal)
      }
      /* Com esus feedback + pec online + treinamento */
      if (
        this.$store.state.orcamento.pec_online === true &&
        this.$store.state.orcamento.treinamento.ativo === true
      ) {
        valorTotal =
          this.computedEmNumero(this.valorMensalEsusFeedback) +
          this.computedEmNumero(this.valorMensalPecOnline) +
          this.computedEmNumero(this.valorTreinamentoMensal)
      }
      if (this.$store.state.orcamento.mea_na_aps === true) {
        valorTotal =
          valorTotal +
          this.$store.state.orcamento.total_equipe *
            this.computedEmNumero(this.valorEquipePorFaixaEsusFeedback)
      }
      return valorTotal
        .toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
        .replace('R$', '')
    },

    /**
     * Retorna o valor total anual do contrato
     *
     * @returns {string}
     */
    valorTotalAnual() {
      let valoTotalAno = null

      if (
        this.$store.state.orcamento.pec_online === false &&
        this.$store.state.orcamento.treinamento.ativo === false
      ) {
        const valorMesFeedback =
          this.$store.state.orcamento.total_equipe *
          this.computedEmNumero(this.valorEquipePorFaixaEsusFeedback)
        const valorAnoFeedback =
          valorMesFeedback *
          (this.$store.state.orcamento.quantidade_meses +
            this.parcelaImplantacao)
        valoTotalAno = valorAnoFeedback + 0
      }
      /* Com esus feedback + pec online */
      if (
        this.$store.state.orcamento.pec_online === true &&
        this.$store.state.orcamento.treinamento.ativo === false
      ) {
        valoTotalAno =
          this.computedEmNumero(this.valorAnualEsusFeedback) +
          this.computedEmNumero(this.valorAnualPecOnline)
      }
      /* Com esus feedback + treinamento */
      if (
        this.$store.state.orcamento.pec_online === false &&
        this.$store.state.orcamento.treinamento.ativo === true
      ) {
        valoTotalAno =
          this.computedEmNumero(this.valorAnualEsusFeedback) +
          this.computedEmNumero(this.valorTreinamentoAnual)
      }
      /* Com esus feedback + pec online + treinamento */
      if (
        this.$store.state.orcamento.pec_online === true &&
        this.$store.state.orcamento.treinamento.ativo === true
      ) {
        valoTotalAno =
          this.computedEmNumero(this.valorAnualEsusFeedback) +
          this.computedEmNumero(this.valorAnualPecOnline) +
          this.computedEmNumero(this.valorTreinamentoAnual)
      }
      if (this.$store.state.orcamento.mea_na_aps === true) {
        const valorMes =
          this.$store.state.orcamento.total_equipe *
          this.computedEmNumero(this.valorEquipePorFaixaEsusFeedback)
        const valorAno =
          valorMes *
          (this.$store.state.orcamento.quantidade_meses +
            this.parcelaImplantacao)
        valoTotalAno = valoTotalAno + valorAno
      }
      return valoTotalAno
        .toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
        .replace('R$', '')
    },

    /**
     * Retorna o dia atual formatado
     *
     * @returns {string}
     */
    dia() {
      const date = new Date()
      const diaHoje = date.getDate()
      let diaString = diaHoje.toString()
      let dia = ''
      if (diaString.length < 2) {
        dia = diaString = `0${diaString}`
      } else {
        dia = diaString
      }
      return dia
    },

    /**
     * Retorna o mês atual por extenso
     *
     * @returns {string}
     */
    mes() {
      const date = new Date()
      const diaMes = date.getMonth() + 1
      let mesExtenso = ''
      switch (diaMes) {
        case 1:
          mesExtenso = 'janeiro'
          break
        case 2:
          mesExtenso = 'fevereiro'
          break
        case 3:
          mesExtenso = 'março'
          break
        case 4:
          mesExtenso = 'abril'
          break
        case 5:
          mesExtenso = 'maio'
          break
        case 6:
          mesExtenso = 'junho'
          break
        case 7:
          mesExtenso = 'julho'
          break
        case 8:
          mesExtenso = 'agosto'
          break
        case 9:
          mesExtenso = 'setembro'
          break
        case 10:
          mesExtenso = 'outubro'
          break
        case 11:
          mesExtenso = 'novembro'
          break
        case 12:
          mesExtenso = 'dezembro'
          break
      }
      return mesExtenso
    },

    /**
     * Retorna o ano atual
     *
     * @returns {number}
     */
    ano() {
      const date = new Date()
      return date.getFullYear()
    },

    /**
     * Retorna os cards agrupados para o relatório
     *
     * @returns {Array}
     */
    cardsRelatorio() {
      const etapa4 =
        this.$store.state.orcamento?.form?.dadosSimulacao
          ?.equipes_implantadas || {}

      const equipes = etapa4.equipes || []

      const ordem = ['regular', 'suficiente', 'boa', 'otima']

      const map = {
        regular: 'Regular',
        suficiente: 'Suficiente',
        boa: 'Bom',
        otima: 'Ótimo',
      }

      return ordem
        .map((key) => {
          const itensAgrupados = {}

          equipes.forEach((item) => {
            if (item.classificacao !== key) {
              return
            }

            const label = this.getGrupoEquipeRelatorio(item)

            if (!itensAgrupados[label]) {
              itensAgrupados[label] = {
                label,
                quantidade: 0,
                valorTotal: 0,
                perdaTotal: 0,
              }
            }

            const quantidade = Number(item.quantidade || 0)
            const valorTotal = Number(item.valorTotal || 0)
            const valorUnitario = Number(item.valorUnitario || 0)
            const valorOtimo = this.getValorOtimoItemRelatorio(item)

            itensAgrupados[label].quantidade += quantidade
            itensAgrupados[label].valorTotal += valorTotal

            if (key !== 'otima') {
              itensAgrupados[label].perdaTotal +=
                quantidade * Math.max(0, valorOtimo - valorUnitario)
            }
          })

          const itens = Object.values(itensAgrupados)

          return {
            key,
            title: map[key],
            itens,
            total: itens.reduce((total, item) => {
              return total + Number(item.valorTotal || 0)
            }, 0),
          }
        })
        .filter((card) => {
          return (
            card.key === 'otima' ||
            card.itens.some((item) => Number(item.quantidade || 0) > 0)
          )
        })
    },

    /**
     * Retorna os totais gerais do relatório
     *
     * @returns {Object}
     */
    totaisRelatorio() {
      const etapa4 =
        this.$store.state.orcamento?.form?.dadosSimulacao
          ?.equipes_implantadas || {}

      return {
        cvat: Number(etapa4.totalCVAT || 0),
        qualidade: Number(etapa4.totalQualidade || 0),
        equidade: Number(etapa4.totalEquidade || this.fixo?.valorCusteio || 0),
        perda: Number(etapa4.totalPerda || 0),
        receber: Number(etapa4.totalReceber || 0),
        maximo: Number(etapa4.totalMaximo || 0),
      }
    },

    /**
     * Retorna o total de CVAT do relatório
     *
     * @returns {number}
     */
    totalCVATRelatorio() {
      return this.totaisRelatorio.cvat
    },

    /**
     * Retorna o total de Qualidade do relatório
     *
     * @returns {number}
     */
    totalQualidadeRelatorio() {
      return this.totaisRelatorio.qualidade
    },

    /**
     * Retorna o total de Equidade do relatório
     *
     * @returns {number}
     */
    totalEquidadeRelatorio() {
      return this.totaisRelatorio.equidade
    },

    /**
     * Retorna o total de perda do relatório
     *
     * @returns {number}
     */
    totalPerdaRelatorio() {
      return this.totaisRelatorio.perda
    },

    /**
     * Retorna o total recebido atualmente no relatório
     *
     * @returns {number}
     */
    totalReceberRelatorio() {
      return this.totaisRelatorio.receber
    },

    /**
     * Retorna o valor máximo possível do relatório
     *
     * @returns {number}
     */
    totalMaximoRelatorio() {
      return this.totaisRelatorio.maximo
    },

    /**
     * Retorna o percentual de progresso do relatório
     *
     * @returns {number}
     */
    progressPercentRelatorio() {
      const max = Number(this.totalMaximoRelatorio || 0)
      const atual = Number(this.totalReceberRelatorio || 0)

      if (max <= 0) {
        return 0
      }

      return Math.max(0, Math.min(100, Math.round((atual / max) * 100)))
    },

    /**
     * Retorna o título do progresso do relatório
     *
     * @returns {string}
     */
    progressTitleRelatorio() {
      return `${this.formatCurrency(
        this.totalReceberRelatorio
      )} de ${this.formatCurrency(this.totalMaximoRelatorio)}`
    },

    /**
     * Retorna o ganho mensal potencial do município
     *
     * @returns {number}
     */
    resumoGanhoMensal() {
      return Number(
        this.$store.state.orcamento?.form?.dadosSimulacao?.equipes_implantadas
          ?.totalPerda || 0
      )
    },

    /**
     * Retorna o ganho anual potencial do município
     *
     * @returns {number}
     */
    resumoGanhoAnual() {
      return this.resumoGanhoMensal * 12
    },
  },
  methods: {
    /**
     * Retorna a quantidade da equipe conforme o label usado nas regras.
     *
     * @param {String} label
     * @returns {Number}
     */
    getQuantidadeEquipe(label) {
      const aliases = {
        'eSF 40h': 'eSF',
      }

      const labelEquipe = aliases[label] || label

      return Number(
        this.$store.state.orcamento?.form?.dadosSimulacao?.equipes_implantadas
          .totaisEquipes?.[labelEquipe] || 0
      )
    },

    /**
     * Calcula os valores do componente vínculo e acompanhamento
     * conforme a classificação informada.
     *
     * @param {String} classificacao
     * @returns {Object}
     */
    valoresComponenteVinculoAcompanhamento(classificacao) {
      const equipes =
        this.$store.state.orcamento.form?.dadosSimulacao?.equipes_implantadas
          ?.equipes || []
      let total = 0

      equipes
        .filter((item) => item.componente === 'CVAT')
        .forEach((item) => {
          const regra = this.regras.vinculo_e_acompanhamento.find((regra) => {
            return regra.label === getLabelRegra(item.equipe)
          })

          if (!regra) return

          const classificacaoEquipe = regra.classificacao.find((el) => {
            return el.tipo === classificacao
          })

          if (!classificacaoEquipe) return

          total += Number(item.quantidade || 0) * classificacaoEquipe.valor
        })

      return {
        text: '',
        total,
      }
    },

    /**
     * Calcula os valores do componente qualidade
     * conforme a classificação informada.
     *
     * @param {String} classificacao
     * @returns {Object}
     */
    valoresComponenteQualidade(classificacao) {
      const equipes =
        this.$store.state.orcamento.form?.dadosSimulacao?.equipes_implantadas
          ?.equipes || []
      let total = 0

      equipes
        .filter((item) => item.componente !== 'CVAT')
        .forEach((item) => {
          const regra = this.regras.qualidade.find((regra) => {
            return regra.label === getLabelRegra(item.equipe)
          })

          if (!regra) return

          const classificacaoEquipe = regra.classificacao.find((el) => {
            return el.tipo === classificacao
          })

          if (!classificacaoEquipe) return

          total += Number(item.quantidade || 0) * classificacaoEquipe.valor
        })

      return {
        text: '',
        total,
      }
    },

    /**
     * Preenche o relatório
     *
     * @returns {void}
     */
    preencherRelatorio() {
      const novasEquipes =
        this.$store.state.orcamento.form.dadosSimulacao.equipes_novas.equipes
      // componente fixo por implantação
      if (novasEquipes != null) {
        let somaComponenteFixoImplantacao = novasEquipes.reduce((acc, item) => {
          return acc + item.valor_implantacao * parseInt(item.value)
        }, 0)

        const quantEsf = novasEquipes.find((el) => el.key == 'esf')?.value
        const quantEAP30h = novasEquipes.find(
          (el) => el.key == 'eap_30h'
        )?.value
        const quantEAP20h = novasEquipes.find(
          (el) => el.key == 'eap_20h'
        )?.value
        const quantESB40h = novasEquipes.find(
          (el) => el.key == 'esb_40h'
        )?.value
        const quantEmultiAmpliada = novasEquipes.find(
          (el) => el.key == 'emulti_ampliada'
        )?.value
        const quantEmultiComplementar = novasEquipes.find(
          (el) => el.key == 'emulti_complementar'
        )?.value
        const quantEmultiEstrategica = novasEquipes.find(
          (el) => el.key == 'emulti_estrategica'
        )?.value
        this.fixo.implantacao = `
          Passa a receber <b>R$ ${somaComponenteFixoImplantacao.toLocaleString(
            'pt-BR',
            {
              minimumFractionDigits: 2,
            }
          )}</b> no componente fixo implantação em parcela única. Esse valor considera: <b>${quantEsf} eSF</b>, <b>${quantEAP30h} eAP 30h</b>, <b>${quantEAP20h} eAP 20h</b>, <b>${quantESB40h} eSB 40h</b>, <b>${quantEmultiAmpliada} eMulti ampliada</b>, <b>${quantEmultiComplementar} eMulti complementar</b> e <b>${quantEmultiEstrategica} eMulti estratégica</b> novas que foram implantadas.
        `
        this.fixo.valorImplantacao = somaComponenteFixoImplantacao
      } else {
        this.fixo.implantacao =
          'O município não tem equipes novas a serem consideradas no componente fixo de implantação.'
      }

      const equipesImplantadas =
        this.$store.state.orcamento.form.dadosSimulacao.equipes_implantadas
          .totaisEquipes

      if (equipesImplantadas != null) {
        // componente fixo por custeio
        const ied = this.$store.state.orcamento.form.dadosSimulacao.ied.value
        const valoresDasEquipesCusteio = this.regras.fixo.custeio.find(
          (item) => item.ied === ied
        )
        let somaComponenteCusteioImplantacao = 0
        valoresDasEquipesCusteio.tipos_equipes.forEach((element) => {
          const quantidadeDeEquipes = this.getQuantidadeEquipe(element.label)
          somaComponenteCusteioImplantacao +=
            element.valor * quantidadeDeEquipes
        })

        // (3 eSF x R$ 16.000) + (0 eAP 30h x R$ 9.600,00) + (0 eAP 20h x R$ 6.400,00) = R$ 48.000,00

        this.fixo.custeio = `
          Passa a receber <b>R$ ${somaComponenteCusteioImplantacao.toLocaleString(
            'pt-BR',
            {
              minimumFractionDigits: 2,
            }
          )}</b> no componente fixo de custeio. Esse valor considera: <b>${
          equipesImplantadas['eSF']
        } eSF</b>, <b>${equipesImplantadas['eAP 30h']} eAP 30h</b>, <b>${
          equipesImplantadas['eAP 20h']
        } eAP 20h</b>.
        `
        this.fixo.valorCusteio = somaComponenteCusteioImplantacao

        // componente de vínculo e acompanhamento
        for (
          let index = 0;
          index < this.vinculo_e_acompanhamento.length;
          index++
        ) {
          const element = this.vinculo_e_acompanhamento[index]
          let val = this.valoresComponenteVinculoAcompanhamento(
            element.classificacao
          )
          element.text = val.text
          element.valorTotal = val.total
        }

        // Componente de qualidade
        for (let index = 0; index < this.qualidade.length; index++) {
          const element = this.qualidade[index]
          let val = this.valoresComponenteQualidade(element.classificacao)
          element.text = val.text
          element.valorTotal = val.total
        }
      }

      //capitação ponderada
      this.capitacao_ponderada =
        this.$store.state.orcamento.form.dadosSimulacao.previne_brasil.capitacaoPonderada.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )

      // pagamento por desempenho
      this.previne_brasil.pagamentoDesempenho =
        this.$store.state.orcamento.form.dadosSimulacao.previne_brasil.pagamentoDesempenho.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )
      // indicadores saúde bucal
      this.previne_brasil.indicadoresSaudeBucal =
        this.$store.state.orcamento.form.dadosSimulacao.previne_brasil.indicadoresSaudeBucal.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )

      // informatiza aps
      this.previne_brasil.informatizaAps =
        this.$store.state.orcamento.form.dadosSimulacao.previne_brasil.informatizaAps.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )

      // pagamento critério populacional
      this.previne_brasil.pagamentoCriterioPopulacional =
        this.$store.state.orcamento.form.dadosSimulacao.previne_brasil.pagamentoCriterioPopulacional.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )
      // per capita
      this.perCapita =
        this.previne_brasil.pagamentoCriterioPopulacional.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )
      this.perCapitaTotal =
        this.$store.state.orcamento.form.dadosSimulacao.previne_brasil.pagamentoCriterioPopulacional

      // Dados gráfico Regular
      this.chartPieSeriesRegular = [
        this.fixo.valorImplantacao,
        this.fixo.valorCusteio,
        this.qualidade[3].valorTotal,
        this.vinculo_e_acompanhamento[3].valorTotal,
        this.perCapitaTotal,
      ]

      // Dados gráfico Suficiente
      this.chartPieSeriesSuficiente = [
        this.fixo.valorImplantacao,
        this.fixo.valorCusteio,
        this.qualidade[2].valorTotal,
        this.vinculo_e_acompanhamento[2].valorTotal,
        this.perCapitaTotal,
      ]

      // Dados gráfico Bom
      this.chartPieSeriesBom = [
        this.fixo.valorImplantacao,
        this.fixo.valorCusteio,
        this.qualidade[1].valorTotal,
        this.vinculo_e_acompanhamento[1].valorTotal,
        this.perCapitaTotal,
      ]

      // Dados gráfico Ótimo
      this.chartPieSeriesOtimo = [
        this.fixo.valorImplantacao,
        this.fixo.valorCusteio,
        this.qualidade[0].valorTotal,
        this.vinculo_e_acompanhamento[0].valorTotal,
        this.perCapitaTotal,
      ]

      this.formatarDadosDaTabelaPorcentagem()
    },

    /**
     * Formata os dados utilizados na tabela de porcentagem
     *
     * @returns {void}
     */
    formatarDadosDaTabelaPorcentagem() {
      let dataClassificacao = ['Ótimo', 'Bom', 'Suficiente', 'Regular']
      let data = []
      for (let index = 0; index < dataClassificacao.length; index++) {
        // classificação
        const classificacao = dataClassificacao[index]
        // vinculo e acompanhamento
        let vinculoAcompanhamento = 0
        let valorVinculoAcompanhamento = this.vinculo_e_acompanhamento.find(
          (item) => item.classificacao === classificacao
        )
        if (valorVinculoAcompanhamento) {
          vinculoAcompanhamento = valorVinculoAcompanhamento.valorTotal
        }
        // qualidade
        let qualidade = 0
        let valorQualidade = this.qualidade.find(
          (item) => item.classificacao === classificacao
        )
        if (valorQualidade) {
          qualidade = valorQualidade.valorTotal
        }
        // recebia
        let recebia = 0
        for (const key in this.$store.state.orcamento.form.dadosSimulacao
          .previne_brasil) {
          const element =
            this.$store.state.orcamento.form.dadosSimulacao.previne_brasil[key]
          recebia += element
        }
        // passa a receber
        const passaAreceber =
          // this.fixo.valorImplantacao +
          this.fixo.valorCusteio +
          vinculoAcompanhamento +
          qualidade +
          this.perCapitaTotal
        // aumentou
        let aumentou = passaAreceber - recebia
        // percentual
        const result = (aumentou / recebia) * 100
        const aumentouPercentual = result.toFixed(2)

        data.push({
          recebia: recebia,
          desempenho: classificacao,
          passaAreceber: passaAreceber,
          aumentou: passaAreceber - recebia,
          aumentouPercentual: aumentouPercentual,
        })
      }

      const otimo = data.find((el) => el.desempenho === 'Ótimo')
      const bom = data.find((el) => el.desempenho === 'Bom')
      const suficiente = data.find((el) => el.desempenho === 'Suficiente')
      const regular = data.find((el) => el.desempenho === 'Regular')
      const diferenca = otimo.passaAreceber - regular.passaAreceber
      this.diferencaMensalOtimoRegular = diferenca

      this.textoTabelaPorcentagem = `
        No cenário de pior desempenho, <b style="color: red">“REGULAR”</b>, o município recebe o valor
            de <b style="color: red">R$
            ${regular.passaAreceber.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            })}</b>
            e no cenário de melhor desempenho, <b style="color: green">“ÓTIMO”</b>, o município recebe o
            valor de <b style="color: green">R$
            ${otimo.passaAreceber.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            })}</b>. A diferença de <b style="color: ${
        diferenca < 0 ? 'red' : 'green'
      }"> R$
            ${diferenca.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            })}</b> está
            relacionada aos componentes de vínculo e acompanhamento e qualidade
            que são os valores variáveis do cofinanciamento federal na APS.

      `
      this.texto2TabelaPorcentagem = `
        No Gráfico 5, pode-se observar que o valor de R$ ${diferenca.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )} representa o quanto o município <b>pode perder por mês</b> entre a classificação <b style='color: green'>“ÓTIMO”</b> e a classificação <b style='color: red'>“REGULAR”</b>.
      `

      this.dadosTabelaPorcentagem = data

      // this.$refs.chartPorcentagem.updateSeries([
      //   {
      //     name: 'Desempenho',
      //     data: [
      //       otimo.passaAreceber,
      //       bom.passaAreceber,
      //       suficiente.passaAreceber,
      //       regular.passaAreceber,
      //     ],
      //   },
      // ])

      const diferencaAnualEntreOtimoRegular =
        otimo.passaAreceber * 12 - regular.passaAreceber * 12
      this.diferencaAnualOtimoRegular = diferencaAnualEntreOtimoRegular

      this.texto3TabelaPorcentagem = `
        No Gráfico 6, pode-se observar que o valor de R$ ${diferencaAnualEntreOtimoRegular.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )} representa o quanto o município <b>pode perder por ano</b> entre a classificação <b style='color: green'>“ÓTIMO”</b> e a classificação <b style='color: red'>“REGULAR”</b>.
      `

      // this.$refs.chartPorcentagemAnual.updateSeries([
      //   {
      //     name: 'Desempenho',
      //     data: [
      //       otimo.passaAreceber * 12,
      //       bom.passaAreceber * 12,
      //       suficiente.passaAreceber * 12,
      //       regular.passaAreceber * 12,
      //     ],
      //   },
      // ])
    },

    /**
     * Retorna o grupo/label da equipe para exibir nos cards do relatório.
     *
     * @param {Object} item
     * @returns {String}
     */
    getGrupoEquipeRelatorio(item) {
      if (item.componente === 'CVAT') {
        return 'CVAT'
      }

      if (item.componente === 'eMulti') {
        return 'eMulti'
      }

      return item.componente || item.equipe
    },

    /**
     * Retorna o valor ótimo do item para calcular a perda.
     *
     * @param {Object} item
     * @returns {Number}
     */
    getValorOtimoItemRelatorio(item) {
      const grupoRegras =
        item.componente === 'CVAT'
          ? regras.vinculo_e_acompanhamento
          : regras.qualidade

      const regra = grupoRegras.find((regra) => {
        return regra.label === getLabelRegra(item.equipe)
      })

      if (!regra) {
        return 0
      }

      const classificacaoOtima = regra.classificacao.find((classificacao) => {
        return classificacao.tipo === 'Ótimo'
      })

      return Number(classificacaoOtima?.valor || 0)
    },

    /**
     * Calcula a perda do card em relação ao ótimo.
     *
     * @param {Object} card
     * @returns {Number}
     */
    perdaCardRelatorio(card) {
      return card.itens.reduce((total, item) => {
        return total + Number(item.perdaTotal || 0)
      }, 0)
    },

    /**
     * Formata valor em moeda brasileira.
     *
     * @param {Number} value
     * @returns {String}
     */
    formatCurrency(value) {
      return Number(value || 0).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })
    },

    /**
     * Converte valor monetário formatado para número
     *
     * @param {string} valor
     * @returns {number}
     */
    computedEmNumero(valor) {
      // Tira os pontos e substitui a virgula por ponto
      let formata = valor.replaceAll('.', '').replaceAll(',', '.')
      let paraFloat = parseFloat(formata)
      return paraFloat
    },

    /**
     * Abre a impressão ou geração de PDF da proposta
     *
     * @returns {void}
     */
    imprimir() {
      document.title = this.$store.state.orcamento.empresa
      window.print()
    },

    /**
     * Realiza o scroll da página para o topo
     *
     * @returns {void}
     */
    topo() {
      window.scrollTo(0, 0)
    },
  },
}
</script>
<style scoped lang="scss" src="./styles.scss" />
<style lang="scss" scoped>
html {
  scroll-behavior: smooth;
}

* {
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
}

.new-page {
  position: relative;
  page-break-before: always;
  page-break-inside: avoid;
}

#proposta {
  margin: 0 auto;
  width: 1200px;
  scroll-behavior: smooth;

  .logo {
    align-self: center;
    width: 140px;
    margin: 25px 0;
  }

  .titulo {
    font-size: 25px;
    margin: 50px 0 30px;
    font-weight: bold;
    text-align: justify;
  }

  .title-2,
  .title-3 {
    font-size: 20px;
    margin: 30px 0;
    font-weight: bold;
    text-align: justify;
  }

  .title-2 {
    text-transform: unset;
  }

  .titulo-principal {
    margin: 20px 0;
    font-size: 20px;
    text-align: center;
    font-weight: 100;
    color: #213669;
    line-height: initial;
  }

  p {
    margin: 15px 0;
    text-indent: 12mm;
  }

  .lista {
    list-style: disc;
    margin-left: 20px;
  }

  .lista-numerica {
    list-style: decimal;
  }

  .lista-ol {
    list-style: auto;
    margin-left: 60px;
  }

  .lista-sem-marcacao-2 {
    list-style: none;
    margin-left: 76px;
  }

  .variaveis,
  .texto-negrito {
    color: #000;
    font-weight: bold;
  }

  .texto-negrito {
    text-align: justify;
  }

  .proposta-link {
    color: #007bff;
    cursor: pointer;
  }

  .tabela {
    width: 100%;
    margin-bottom: 16px;
    border: 1px solid #000;
    color: #000;

    th,
    td {
      border: 1px solid #000;
      color: #000;
    }

    thead {
      background: #d9d9d9;
      color: #000;
      text-align: center;

      th {
        padding: 10px;
        border-bottom: 0;
      }
    }

    tbody {
      td {
        padding-left: 10px;

        &:nth-child(1),
        &:nth-child(4),
        &:nth-child(5),
        &:nth-child(6) {
          text-align: left;
        }

        &:nth-child(2),
        &:nth-child(3) {
          text-align: center;
        }

        &:nth-child(5),
        &:nth-child(6) {
          font-weight: bold;
        }

        &:nth-child(4),
        &:nth-child(5),
        &:nth-child(6) {
          span:last-child {
            float: right;
            margin-right: 10px;
          }
        }
      }
    }
  }

  .footer {
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
  }

  .btn {
    border-radius: 32px;
    display: inline-block;
    background-color: #0fafd7;
    color: #fff;
    font-size: 15px;
    padding: 0 30px;
    text-transform: uppercase;
    font-weight: 700;
    box-shadow: inset 0 -2px 0 rgb(0 0 0 / 25%);

    &:hover {
      background: #0fafd7;
      color: #0056b3;
    }
  }

  .imprimir {
    position: absolute;
    right: 0;
    top: 10px;
  }

  .topo {
    text-align: end;
    margin: 30px 0;
  }
}

/* =========================
   Cards de resumo
========================= */

.resumo-equipes-simulacao {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
}

.resumo-card {
  width: 280px;
  max-width: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 12px 35px rgba(15, 23, 42, 0.12);

  &__top {
    height: 10px;
  }

  &.regular &__top {
    background: #c46500;
  }

  &.suficiente &__top {
    background: #d5ba0a;
  }

  &.boa &__top {
    background: #00a878;
  }

  &.otima &__top {
    background: #2f80b7;
  }

  &__body {
    padding: 18px;

    h4 {
      margin: 0 0 18px;
      text-align: center;
      font-size: 14px;
      font-weight: 800;
    }
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 10px 0;
    border-bottom: 1px solid #edf2f7;
    font-size: 12px;

    .valor {
      white-space: nowrap;
      font-weight: 800;
      color: #0f172a;
    }

    &--empty {
      justify-content: center;
      color: #64748b;
      font-style: italic;
    }
  }

  &__info {
    display: flex;
    align-items: center;
    gap: 8px;

    .qtd {
      padding: 6px 10px;
      border: 1px solid #d7e8ff;
      border-radius: 9px;
      background: #eff6ff;
      color: #2b6cb0;
      font-weight: 800;
      text-align: center;
    }
  }

  &__total {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;
    padding: 14px;
    border-radius: 12px;
    background: #f8fafc;
    font-weight: 800;
    font-size: 12px;
  }
}

.simulador-perda,
.simulador-otimo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  padding: 12px;
  margin-top: 10px;
  font-weight: 800;
  font-size: 12px;
}

.simulador-perda {
  background: #fef2f2;
  color: #dc2626;
}

.simulador-otimo {
  background: #f0fdf4;
  color: #15803d;

  i {
    font-size: 16px;
  }
}

.simulador-resultado {
  margin-top: 28px;
  background: #fff;
  border-left: 8px solid #3f84b6;
  border-radius: 28px;
  padding: 28px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);

  p {
    margin: 0 !important;
    font-size: 18px !important;
    color: #334155;
    line-height: 1.6;
    text-indent: 0 !important;
  }

  &__valor-atual {
    color: #16a34a;
  }

  &__valor-ganho {
    color: #f59e0b;
  }
}

.simulador-resumo-progress {
  margin-top: 22px;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid #f1f5f9;
  border-radius: 24px;
  padding: 16px 18px 18px;

  &__row {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 18px;
    align-items: start;
  }

  &__metric {
    display: flex;
    align-items: center;
    min-width: 0;

    &.is-recebendo {
      .simulador-resumo-progress__value {
        color: #16a34a;
      }
    }

    &.is-ganho {
      .simulador-resumo-progress__value {
        color: #f59e0b;
      }
    }

    &.is-maximo {
      .simulador-resumo-progress__value {
        color: #354abb;
      }
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 7px;
    min-width: 0;
  }

  &__label {
    display: block;
    font-size: 12px;
    font-weight: 900;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__value {
    font-size: 28px;
    font-weight: 900;
    margin: 0;
    line-height: 1.1;
  }

  &__bar {
    position: relative;
    margin-top: 14px;
    padding-top: 12px;
  }

  &__track {
    height: 10px;
    background: #e2e8f0;
    border-radius: 999px;
    overflow: hidden;
  }

  &__fill {
    position: absolute;
    left: 0;
    top: 12px;
    height: 10px;
    background: linear-gradient(90deg, #16a34a 0%, #f59e0b 55%, #354abb 100%);
    border-radius: 999px;
    transition: width 180ms ease;
  }

  &__caption {
    margin-top: 10px;
    font-size: 12px;
    font-weight: 900;
    color: #64748b;
    text-align: right;
  }
}

@media print {
  .simulador-resumo-progress {
    margin-top: 18px !important;
    border: 1px solid #f1f5f9 !important;
    border-radius: 24px !important;
    padding: 16px 18px 18px !important;
    background: rgba(255, 255, 255, 0.72) !important;
    box-shadow: none !important;

    break-inside: avoid !important;
    page-break-inside: avoid !important;

    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;

    &__row {
      display: grid !important;
      grid-template-columns: 1fr 1fr 1fr !important;
      gap: 18px !important;
      align-items: start !important;
    }

    &__metric {
      display: flex !important;
      align-items: center !important;
      min-width: 0 !important;
    }

    &__content {
      display: flex !important;
      flex-direction: column !important;
      gap: 7px !important;
      min-width: 0 !important;
    }

    &__label {
      display: block !important;
      font-size: 10px !important;
      font-weight: 900 !important;
      color: #94a3b8 !important;
      text-transform: uppercase !important;
      letter-spacing: 0.6px !important;

      white-space: nowrap !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
    }

    &__value {
      font-size: 22px !important;
      font-weight: 900 !important;
      margin: 0 !important;
      line-height: 1.1 !important;
    }

    &__metric.is-recebendo {
      .simulador-resumo-progress__value {
        color: #16a34a !important;
      }
    }

    &__metric.is-ganho {
      .simulador-resumo-progress__value {
        color: #f59e0b !important;
      }
    }

    &__metric.is-maximo {
      .simulador-resumo-progress__value {
        color: #354abb !important;
      }
    }

    &__bar {
      position: relative !important;
      margin-top: 14px !important;
      padding-top: 12px !important;
    }

    &__track {
      height: 10px !important;
      background: #e2e8f0 !important;
      border-radius: 999px !important;
      overflow: hidden !important;

      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    &__fill {
      position: absolute !important;
      left: 0 !important;
      top: 12px !important;
      height: 10px !important;

      background: linear-gradient(
        90deg,
        #16a34a 0%,
        #f59e0b 55%,
        #354abb 100%
      ) !important;

      border-radius: 999px !important;

      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    &__caption {
      margin-top: 10px !important;
      font-size: 10px !important;
      font-weight: 900 !important;
      color: #64748b !important;
      text-align: right !important;
    }
  }
}

/* =========================
   Tela
========================= */

@media screen {
  .footer2,
  .imagem-header {
    display: none;
  }
}

@media screen and (max-width: 656px) {
  #proposta {
    margin: 0 15px;
    width: 100%;
  }

  .resumo-equipes-simulacao {
    grid-template-columns: 1fr;
  }
}

/* =========================
   Impressão
========================= */

@media print {
  @page {
    margin: 10mm 15mm;
  }

  #proposta {
    position: relative;
    padding: 0;
    margin: 0;
    width: 100%;
    min-height: initial;

    .col-lg-6 {
      width: 50%;
    }

    .new-page {
      margin: 0;
      padding: 0;
      width: 100%;
      page-break-before: always;
      page-break-inside: avoid;
    }

    .quebrar-pagina {
      page-break-before: always;
      break-before: page;
    }

    .titulo-principal {
      text-align: center !important;
      font-size: 18pt;
      font-weight: 100;
      color: #213669;
    }

    .titulo {
      margin: 30px 0;
    }

    .title-2,
    .title-3 {
      margin: 20px 0;
    }

    p,
    ul,
    ol,
    .lista-ol,
    .lista-numerica {
      font-size: 16pt;
    }

    .tabela {
      font-size: 16px;
      width: 100%;
    }

    .footer {
      width: 100%;
      margin: 0;

      span,
      span a {
        margin: 0;
      }
    }

    .atenciosamente {
      margin-top: 200pt;
    }

    .imprimir,
    .topo {
      visibility: hidden;
    }

    .logo {
      width: 150px;
    }
  }

  .imagem-header {
    display: flex;
    justify-content: center;
    margin-bottom: 1px;
  }

  .footer2 {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 30mm;
    margin: 0;
    padding: 0;
    border-top: 2px solid #0b3161;
    background-color: #f1f1f1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 999 !important;

    .left,
    .right {
      width: 49%;
    }

    p,
    span {
      color: #2246739b;
    }

    p {
      margin-bottom: 0;
    }

    .contato,
    .endereco {
      background-color: #c3e8fa;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    .contato {
      text-align: justify;
      display: flex;
      flex-direction: column;
      align-items: center;

      .icone-whatsapp {
        display: inline-block;
        transform: rotate(272deg);
        margin-right: 5px;
      }

      .icone-instagram,
      .icone-youtube {
        margin-right: 5px;
      }

      .redes-sociais {
        display: flex;
        gap: 10px;
      }
    }

    .endereco {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .imagem {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 10px;

      .logo-footer {
        max-width: 70px;
      }
    }
  }

  .resumo-equipes-simulacao {
    display: flex !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
    align-items: flex-start;
    width: 100%;
    gap: 10px;
  }

  .resumo-card {
    width: 240px;
    max-width: 240px;
    flex: 0 0 240px;
    background: #fff !important;
    border: 1px solid #dbe2ea !important;
    border-radius: 16px !important;
    box-shadow: none !important;
    overflow: hidden !important;
    break-inside: avoid !important;
    page-break-inside: avoid !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;

    &__top {
      height: 10px !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    &.regular .resumo-card__top {
      background-color: #c46500 !important;
    }

    &.suficiente .resumo-card__top {
      background-color: #d5ba0a !important;
    }

    &.boa .resumo-card__top {
      background-color: #00a878 !important;
    }

    &.otima .resumo-card__top {
      background-color: #2f80b7 !important;
    }

    &__body {
      padding: 12px !important;

      h4 {
        font-size: 13px !important;
        margin-bottom: 10px !important;
      }
    }

    &__item {
      padding: 7px 0 !important;
      font-size: 10px !important;
      border-bottom: 1px solid #edf2f7 !important;
    }

    &__info {
      .qtd {
        background-color: #eff6ff !important;
        border: 1px solid #d7e8ff !important;
        color: #2b6cb0 !important;
        border-radius: 8px !important;
        padding: 4px 8px !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
    }

    &__total {
      background-color: #f8fafc !important;
      border-radius: 10px !important;
      padding: 10px !important;
      font-size: 10px !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
  }

  .simulador-perda {
    background-color: #fef2f2 !important;
    color: #dc2626 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  .simulador-otimo {
    background-color: #f0fdf4 !important;
    color: #15803d !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
}
</style>
